import { Link } from "react-router-dom";
import { useLanguage } from "../context/LanguageContext";
import { TOOLS_LIST, EXCEL_TOOLS_LIST } from "../translations";
import { SEO_PAGES_CONFIG } from "../seoPagesConfig";
import { buildLocalizedPath } from "../i18nConfig";
import {
  Merge, Minimize2, Scissors, FileText, FileOutput,
  AlignLeft, Eye, Table2, ImageDown, RotateCw, Trash2, Lock
} from "lucide-react";

const ICON_MAP = { Merge, Minimize2, Scissors, FileText, FileOutput, AlignLeft, Eye, Table2, ImageDown, RotateCw, Trash2, Lock };

export default function RelatedTools({ toolKey }) {
  const { t, lang } = useLanguage();
  const relatedSlugs = SEO_PAGES_CONFIG.find((p) => p.toolKey === toolKey)?.relatedTools || [];
  const allTools = [...TOOLS_LIST, ...EXCEL_TOOLS_LIST];
  const related = allTools.filter((tool) => relatedSlugs.includes(tool.slug)).slice(0, 4);

  if (related.length === 0) return null;

  const label = t.nav?.relatedTools || (lang === "fr" ? "Outils associés" : lang === "es" ? "Herramientas relacionadas" : lang === "pt" ? "Ferramentas relacionadas" : lang === "de" ? "Verwandte Tools" : "Related Tools");

  return (
    <section className="mt-8" data-testid="related-tools">
      <h2
        className="text-lg font-bold text-slate-800 mb-4"
        style={{ fontFamily: "'Outfit', sans-serif" }}
      >
        {label}
      </h2>
      <div className="grid grid-cols-2 gap-3">
        {related.map((tool) => {
          const Icon = ICON_MAP[tool.icon] || FileText;
          return (
            <Link
              key={tool.slug}
              to={buildLocalizedPath(tool.slug, lang)}
              data-testid={`related-tool-${tool.slug}`}
              className="flex items-center gap-3 p-4 rounded-xl border border-slate-200 bg-white hover:border-blue-300 hover:shadow-sm hover:-translate-y-0.5 transition-all duration-200 group"
            >
              <div
                className="w-9 h-9 rounded-lg flex items-center justify-center flex-shrink-0"
                style={{ backgroundColor: `${tool.color}15` }}
              >
                <Icon className="w-4 h-4" style={{ color: tool.color }} />
              </div>
              <span className="text-sm font-medium text-slate-700 group-hover:text-blue-600 transition-colors">
                {t.tools[tool.key]?.title || tool.key}
              </span>
            </Link>
          );
        })}
      </div>
    </section>
  );
}
